module.exports = __webpack_public_path__ + "static/img/_82A3652.354efd7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/introduction/_82A3652.jpg
// module id = 5N7V
// module chunks = 0